<template>
  <div class="">
    <Landing :landingData="landingData" />
    <AboutInstructor id="about" :instructorData="instructorData" />
    <ProgramInfo id="program" :info="programData" />
    <BasicRequirement :info="basicRequirement" />
    <PositionSummary :info="positionInfo" />
    <TestimonialCompany :info="companyTestimonial" style="padding-top:40px" />
    <Faq id="faq" :info="faq" />
    <Contact bgColor="#3A3A4C" />
  </div>
</template>
<script>
import AboutInstructor from '../../../components/AssessmentIsa/AboutTheCompany.vue'
import TestimonialCompany from '../../../components/AssessmentIsa/CompanyTestimonial.vue'
import Landing from '../../../components/AssessmentIsa/LandingAssessment.vue'
import ProgramInfo from '../../../components/AssessmentIsa/ProgramInfo.vue'
import Contact from '../../../components/isaMain/Contact.vue'
import PositionSummary from '../../../components/AssessmentIsa/PositionSummary.vue'
import BasicRequirement from '../../../components/AssessmentIsa/BasicReq.vue'
import Faq from '../../../components/shera/Faq.vue'

export default {
  data() {
    return {
      landingData: {
        title1: 'Apply for the Business Project Manager Role ',
        //   subTitle: 'Senior Marketing Executive (Contractual)',
        paragraph:
          'Get a chance to work as a ‘ Business Project Manager’ at Bongo by taking the assessment curated by Upskill.  ',
        companyLogo: '',
        quizLink:
          'https://quiz.upskill.com.bd/assessment/2e3aae92-5649-464b-a4fc-3499afe78564?public=true&job=bongo_project_manager',
        landingImage: require('../../../assets/bongo/18775.png'),
        spanColor: 'grey',
      },
      instructorData: {
        //   name: 'Fayaz Taher',
        avatar: require('../../../assets/bongo/Bongo_logo 1.png'),
        info:
          'Bongo is an international media-tech company that is empowering the masses through the creation, distribution, and monetization of video content. At Bongo, we believe access to content and media to be a right, not a privilege. Ultimately, this is what drives us every day in our mission to create a digital ecosystem catering to our key demographics in primarily frontier markets such as Bangladesh, India, etc. but also in other global markets such as Europe/N. America.',
        designation: '',

        bgColor: '#DDEAFA',
        txtColor: '#29292B',
      },
      programData: {
        headingInfo:
          'Business Project Manager - Studios Assessment consists of approximately 15 MCQs. You are required to pass the  assessment test with a minimum of 60% of the total score.Top 5-10 Candidates will get the chance to go to the interview round after completing the assessment. So, don’t miss this opportunity as the time is limited!',
        seatsInfo: '',
        startDate: '15th February',
        cost: 'Free',
        deadline: '27th February',
        courseOutlineLink:
          'https://upskill-files.s3.ap-southeast-1.amazonaws.com/Financial+Analyst/Course+Outline+for+Financial+Analyst.pdf',

        quizLink:
          'https://quiz.upskill.com.bd/assessment/37a6c7d6-f21c-48e1-968e-74336c5109c3?public=true&job=isa_financial_analyst',
        bgColor: '#1EBCE5',
        txtColor: '#5277F7',
      },
      positionInfo: {
        paragraph:
          'This role is within the department Bongo Studios (www.bongostudios.com), which is the fastest-growing vertical within Bongo. Bongo Studios is a Multi-Channel Network (MCN) of a community of creative and independent content producers from multiple countries. We nurture talent and optimize content for our creators to help them achieve enhanced growth and monetization on multiple platforms (YouTube, Facebook, BongoBD, etc.). Currently, our creators reach over 180 million subscribers and have over 1.5 billion views per month.For this job role, we are looking for someone who is PMP certified and hassuccessfully managed a large team for at least 3 years, at a well-recognized company.The ideal candidate will be responsible for planning, coordinating, and managing the team within the timeline, budget, scope, and targets set for the department. They will also effectively monitor and present the updates to relevant stakeholders, clients, and team members.',
        remote: '',
        jobType: 'Job Type: Full-time ',
        txtColor: '#5277F7',
      },
      companyTestimonial: {
        mainImg: require('../../../assets/bongo/CTO_Bongo_Shadid 1.png'),
        name: 'Shadid Haque',
        paragraph:
          'At Bongo we believe in human-centric designs because people ignore design that ignores people. We are very excited to team up with Upskill in our mission to recruit the very best talents from all walks of life. We welcome anyone who wants to solve problems that impact millions of users and be part of a team that is empowered to do so.',
        designation: 'CTO  of Bongo',
        imgBg: '#DDEAFA',
        invertedCommaBg: '',
        //   firstComma: require('../assets/Canadian Tech company/“.svg'),
        //   secondComma: require('../assets/Canadian Tech company/Group 22.svg'),
      },
      basicRequirement: {
        mainContent: [
          ' PMP certification is a must for this role  ',
          'Minimal 8 to 10 years of total working experience, of which at least 2 years managing a team of 10+ people ',
          'A Basic understanding of how monetization on platforms such as Youtube and Facebook works and experience in this area. ',
          'Proven experience in successfully managing scalable growth in a fast-paced environment ',
          'Track record of being process-oriented and data-driven',
          'Previous experience in e-commerce, digital marketing, or digital content is a bonus, but not required ',
          'Enthusiastic to work in a dynamic start-up environment with a young and diverse team in several countries ',
          'Fluent English and Bangla language proficiency (Nepali, Hindi, or Sinhala are a plus, but not required) ',
          'Ability to analyze data to find trends and problems ',
          'Proficient in Office 365, Google Suite, and other desktop solutions ',
        ],
        bgColor: '#184DBD',
      },

      outlineColor: {
        color: '#EA4424',
      },

      faq: [
        {
          title: 'What is the duration of the assessment? \n',
          content: '10 minutes. \n',
          category: 'FAQ',
        },
        {
          title: 'What is the assessment  fee? \n',
          content: 'It is free',
          category: 'FAQ',
        },
        {
          title: 'Do you need previous work experience? \n',
          content:
            'Yes, Minimal 8 to 10 years of total working experience, of which at least 2 years managing a team of 10+ people.\n',
          category: 'FAQ',
        },
        {
          title: 'How much do I need to secure to qualify?\n',
          content: '60% of the total score i.e. 6 out of 10',
          category: 'FAQ',
        },

        {
          title: 'How many times can I take the quiz?\n',
          content:
            'You can take the quiz twice. The highest score will be counted as the final score.\n',
          category: 'FAQ',
        },
        {
          title: 'Will all the top 5 students get a job at Bongo?\n',
          content:
            'No, the top 5 students will get a chance to interview at Bongo, and will get the job depending on their performance in the interview.\n',
          category: 'FAQ',
        },
        {
          title: 'Salary?\n',
          content: ' Market Competitive Salary  \n',
          category: 'FAQ',
        },
      ],
    }
  },
  components: {
    Landing,
    AboutInstructor,
    Faq,
    ProgramInfo,
    Contact,
    TestimonialCompany,
    BasicRequirement,
    PositionSummary,
  },
  created() {
    this.Loaded()
  },
}
</script>
